import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingMessageProps {
  isAuthMessage?: boolean
  isQueryMessage?: boolean
  isPostMessage?: boolean
  isDownloadMessage?: boolean
}

//TODO Improve this
//Remove logic, simplify, pass loadingMessage objects as spread props

export default function LoadingMessage(props: LoadingMessageProps) {
  const { isAuthMessage, isQueryMessage, isPostMessage, isDownloadMessage } =
    props

  const centeredFullScreenSx = {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  if (isAuthMessage) {
    return (
      <Box sx={centeredFullScreenSx}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress color="info" size={18} />
          <Box sx={{ marginLeft: '4px' }}>
            <Typography variant="body1" color={'#78869E'}>
              Checking authentication...
            </Typography>
            <Typography variant="body1" color={'#78869E'}>
              Will take a couple seconds
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }

  if (isQueryMessage) {
    return (
      <Box
        sx={{
          marginTop: '8px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress color="info" size={18} />
        <Box sx={{ marginLeft: '4px' }}>
          <Typography variant="body2" color="#78869E">
            Retrieving information...
          </Typography>
        </Box>
      </Box>
    )
  }

  if (isPostMessage) {
    return (
      <Box
        sx={{
          textAlign: 'center',
        }}
      >
        <CircularProgress color="info" />
        <Box sx={{ marginTop: '4px' }}>
          <Typography variant="h3" color="#78869E">
            Information is loading...
          </Typography>
          <Typography variant="body2" color={'#78869E'}>
            Will take a couple seconds
          </Typography>
        </Box>
      </Box>
    )
  }

  if (isDownloadMessage) {
    return (
      <Box sx={centeredFullScreenSx}>
        <CircularProgress color="info" size={18} />
        <Box sx={{ marginLeft: '4px' }}>
          <Typography variant="body1" color="#78869E">
            Downloading file...
          </Typography>
        </Box>
      </Box>
    )
  }

  // Base case
  return (
    <Box
      sx={{
        textAlign: 'center',
      }}
    >
      <CircularProgress color="info" />
      <Box sx={{ marginTop: '4px' }}>
        <Typography variant="h3" color="#78869E">
          Information is loading...
        </Typography>
        <Typography variant="body2" color={'#78869E'}>
          Will take a couple seconds
        </Typography>
      </Box>
    </Box>
  )
}
